<template>
	<div class="flex_1 margin_horizontal">
		<PaymentTable></PaymentTable>
	</div>
</template>
<script>
import PaymentTable from "@/components/templates/seller/payments/PaymentTable.vue";

export default {
	components: { PaymentTable },
	data() {
		return {};
	}
};
</script>